import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the notification state domain
 */

const selectNotificationDomain = state => state.notification || initialState;

const makeSelectNotificationState = () =>
  createSelector(
    selectNotificationDomain,
    subState => subState
  );

export { makeSelectNotificationState };
